import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

import { MagnifyingGlass } from "../../assets/icons";

import styles from "./ArtWarehouseSearch.module.scss";

/**
 *
 * @param {{ searchValue: string, setInputFocus: function, setSearchValue: function, placeholder: string }} props
 * @returns react element
 */
const ArtWarehouseSearch = (props) => {
  const {
    searchValue,
    setInputFocus,
    setSearchValue,
    setOpacityClass,
    placeholder
  } = props;
  const [focused, setFocused] = useState(false);
  const [localSearchValue, setLocalSearchValue] = useState(searchValue);
  const { t } = useTranslation();

  useEffect(() => {
    setInputFocus(focused);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [focused]);

  useEffect(() => {
    setLocalSearchValue(searchValue);
  }, [searchValue]);

  useEffect(() => {
    setFocused(false);
    setOpacityClass("noOpacity");
    setSearchValue(localSearchValue);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [localSearchValue]);

  const onFocus = () => setFocused(true);
  const onBlur = () => setFocused(false);

  return (
    <div className={styles.search}>
      <input
        type="text"
        onFocus={onFocus}
        onBlur={onBlur}
        value={localSearchValue}
        onChange={(e) => setLocalSearchValue(e.target.value)}
        placeholder={
          placeholder ||
          `${t("search.placeholder")} ${t("search.placeholder_example")}`
        }
      />

      <MagnifyingGlass className={styles.searchIcon} />
    </div>
  );
};

export default ArtWarehouseSearch;
